import caseAddedIcon from '@/pages/_app/dashboard/ui/icons/case-added-icon.svg'
import caseDeletedIcon from '@/pages/_app/dashboard/ui/icons/case-deleted-icon.svg'

import { CASE_OPERATION_HISTORY_ACTION_TYPE_MAP } from '@/lib/queries/business/v1/case/logs/constants'
import { type CaseAddDeleteHistoryItem } from '@/lib/queries/business/v1/case/logs/types'
import { cn } from '@/lib/utils'

export interface CaseActivityHistoryItemProps {
  data: CaseAddDeleteHistoryItem
}

export const CaseActivityHistoryItem = ({ data }: CaseActivityHistoryItemProps) => {
  const { actionType, message } = data

  const isAddedActionType = actionType === CASE_OPERATION_HISTORY_ACTION_TYPE_MAP.add
  const isDeletedActionType = actionType === CASE_OPERATION_HISTORY_ACTION_TYPE_MAP.delete

  return (
    <div className={cn('flex', 'px-5 py-4')}>
      <div>
        {isAddedActionType && (
          <img src={caseAddedIcon} alt="Case added icon" className={cn('w-7', 'h-7', 'rounded-[50%]')} />
        )}
        {isDeletedActionType && (
          <img src={caseDeletedIcon} alt="Case deleted icon" className={cn('w-7', 'h-7', 'rounded-[50%]')} />
        )}
      </div>

      <div className={cn('flex flex-col gap-y-2.5', 'ml-2.5')}>
        <p className={cn('text-sm font-normal leading-7 text-slate-600')}>
          {isAddedActionType && 'Case Added'}
          {isDeletedActionType && 'Case Deleted'}
        </p>
        <p className={cn('text-base font-medium text-foreground')}>{message}</p>
      </div>
    </div>
  )
}
